import React, { Component } from 'react';

import SideNav from '../sidenav/Sidenav.js';
import { CrfContext } from '../../CrfContext';
import { Redirect } from 'react-router-dom';

import { Transition, animated } from 'react-spring/renderprops';
import { getData, localValidation, allowNumberInputs } from './actions';
import DraftView from './DraftView';

import axios from 'axios';
import PoModal from '../poitems/PoModal';
import PoModalReturned from './PoModal';
import savedReturned from 'API/functions/savedReturned.js';
import { Modal } from 'materialize-css';

export class NonPoItems extends Component {
  state = {
    progress: 0,
    releasingCenter: '',
    userDeptList: [],
    isLoading: false,
    dueDate: '',

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    requestType: '',
    vendor: '',
    vendorError: false,
    vendorErr: 1,
    particulars: '',
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: '',
    poNumber: null,
    poNumberError: false,
    poNumberErr: 1,
    project: '',
    projectError: false,
    projectErr: 1,
    subProject: '',
    file: null,
    fileText: null,
    fileError: false,
    fileErr: 1,
    budgetLineItem: '',
    termDays: '',
    receivingDate: '',
    projectClass: [
      {
        glCategory: '',
        glAccount: '',
        description1: '',
        description2: '',
        itemNumber: '',
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: '1OV',
        vatType: 'None IVAT-X1',
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: 'X1',
        wTaxTypeValue: 0,
        wTaxTypeString: '',
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: '',
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
      },
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0,
    glCategory: '',
    projectCode: '',
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: '',
    accountTypes: [],
    itemNoList: [],

    redirect: false,
    crfId: '',

    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],

    subNetList: [],

    vatTypeSelector: '',
    vatTypeSelected: '',

    wTaxRates: [],

    vendorLists: [],
    projectLists: [],

    cocExpenses: [],
    advances: [],
    ppeAccounts: [],
    adminExpenses: [],
    advancesProjectClass: [],

    accountCodeAndName: [],
    error: 0,

    removal: false,
    target: null,
    addProjectClass: false,

    requestId: '',
    accountTypes: [],
  };

  onBlurNumber = (e, index, key) => {
    if (key === 'quantity') {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (e.target.value === '0' || e.target.value === '') {
        obj[key] = 1;
        projectClass[index] = obj;
        this.setState({
          projectClass,
        });
        return;
      }
    }

    if (key === 'grossPricePerItem') {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (e.target.value === '') {
        obj[key] = 0;
        projectClass[index] = obj;
        this.setState({
          projectClass,
        });
        return;
      }
    }
  };

  handleWTaxRate = async (wTaxType) => {
    try {
      const { data } = await getData(`/api/withHoldingTax/wTaxRate/${wTaxType}`);
      return data.Rate;
    } catch (err) {
      return '0';
    }
  };
  projectClassComputation = async (qty, grossPrice, vatType, wTaxType, projectClass, index, key) => {
    const data = {
      rate: projectClass[index].wTaxRate,
    };
    if (key === 'wTaxType') {
      data.rate = await this.handleWTaxRate(wTaxType);
    }
    const subTotalGrossPrice = (qty === '' ? 1 : parseInt(qty)) * parseFloat(grossPrice === '' ? 0 : grossPrice);
    const unitPrice = subTotalGrossPrice / (vatType === 'None IVAT-X1' ? 1 : 1.12);
    const netVat = subTotalGrossPrice - unitPrice;
    const netWTax = unitPrice * (data.rate * 0.01);
    const subTotalNetPrice = subTotalGrossPrice - netWTax;
    projectClass[index].quantity = qty;
    projectClass[index].grossPricePerItem = grossPrice;
    projectClass[index].vatType = vatType;
    projectClass[index].wTaxCode = wTaxType;
    projectClass[index].wTaxType = wTaxType;
    projectClass[index].wTaxRate = data.rate;
    projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2);
    projectClass[index].subTotalNetPrice = data.rate === '0' ? subTotalGrossPrice.toFixed(2) : subTotalNetPrice.toFixed(2);

    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;

    for (let obj of projectClass) {
      requestingGrossPrice = parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount = parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  onChangedHandler = (event, index, key) => {
    if (key === 'poNumber') {
      if (event.target.value.length <= 9) {
        const poNumber = allowNumberInputs(event.target.value);
        this.setState({
          poNumber,
        });
      }
      return;
    }
    if (key === 'dueDate') {
      this.setState({
        dueDate: event.target.value,
      });
    }
    if (key === 'quantity') {
      const projectClass = [...this.state.projectClass];
      const obj = { ...projectClass[index] };
      if (event.target.value === '0' || event.target.value === ' ') {
        obj.quantity = '';
      } else {
        if (event.target.value.length > 9) {
          const qtyCopy = event.target.value.slice(0, -1);
          const quantity = allowNumberInputs(qtyCopy);
        } else {
          const quantity = allowNumberInputs(event.target.value);
          this.projectClassComputation(
            quantity.trim(),
            this.state.projectClass[index].grossPricePerItem,
            this.state.projectClass[index].vatType,
            this.state.projectClass[index].wTaxCode,
            projectClass,
            index,
            'quantity'
          );
        }
      }
    }

    this.handleChangeProjectClassValue(event, index, key);
    const projectClassArray = [...this.state.projectClass];
    const projectClassObject = { ...projectClassArray[index] };
    projectClassArray[index] = projectClassObject;
    this.setState({
      projectClass: projectClassArray,
    });
  };
  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showForm: true,
      });
    }, 500);

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.crfId}`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then(async (response) => {
        const data = response.data.data;
        const fileText = data.supportingDocuments ? data.supportingDocuments : null;

        let requestingGrossPrice = 0.0;
        let requestingAmount = 0.0;
        for (let obj of data.projectClasses) {
          const glAccountCopy = { ...obj.glAccount };
          obj.glCategory = glAccountCopy.budgetLineItem;
          obj.glAccount = glAccountCopy.accountCode;
          obj.projectClass = glAccountCopy.centerName;
          obj.budgetLineItem = glAccountCopy;
          obj.wTaxType = obj.wTaxCode;
          obj.wTaxRate = await this.handleWTaxRate(obj.wTaxCode);
          obj.subTotalGrossPrice = parseFloat(obj.apv.subTotalGrossPrice).toFixed(2);
          obj.subTotalNetPrice = parseFloat(obj.apv.subTotalNetPrice).toFixed(2);

          requestingGrossPrice = parseFloat(obj.apv.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
          requestingAmount = parseFloat(obj.apv.subTotalNetPrice) + parseFloat(requestingAmount);
        }

        this.setState({
          requestId: data._id,
          requestType: response.data.data.requestType,
          projectClass: data.projectClasses,
          requestingGrossPrice: requestingGrossPrice.toFixed(2),
          requestingAmount: requestingAmount.toFixed(2),
          fileText,
          termDays: data.termDays,
          receivingDate: data.receivingDate.split('T')[0],
          dueDate: data.dueDate.split('T')[0],
        });

        if (data.poNumber) {
          this.setState({
            poNumber: data.poNumber,
          });
        }

        if (data?.releasingCenter) {
          this.setState({
            releasingCenter: data?.releasingCenter,
          });
        }

        if (data.department) {
          this.setState({
            requestingDepartment: response.data.data.department.centerName,
          });
        }
        if (data.vendor) {
          this.setState({ vendor: data.vendor.bpName });

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/vendors/${data.vendor.bpName}`,
            headers: {
              'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              this.setState({
                vatTypeSelector: response.data.data.vatType,
              });

              axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
                headers: {
                  'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`,
                },
              })
                .then((wow) => {
                  let newArray = wow.data.data;
                  const none = {
                    wTaxCode: 'X1',
                    wTaxName: '',
                    wTaxDisplayName: 'None X1',
                    rate: '0',
                  };
                  newArray.push(none);
                  this.setState({
                    wTaxRates: wow.data.data,
                  });
                })
                .catch((error) => {});
            })
            .catch((error) => {});
        }

        if (data.particulars) {
          this.setState({ particulars: data.particulars });
        }

        if (data.project) {
          if (data.project) {
            this.setState({ project: data.project.projectName });
          } else {
            this.setState({ project: data.project.projectName });
          }
          const params = {
            projectCode: data.project.projectCode,
            department: data.department.centerName,
          };
          axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem/dropdown`,
            headers: {
              'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`,
            },
            data: params,
          })
            .then((response) => {
              //
              let budgetLineItem = response.data.data;
              this.setState({
                accountTypes: budgetLineItem,
              });
            })
            .catch((error) => {
              this.setState({
                accountTypes: [],
              });
            });
        }

        if (data.subProject) {
          this.setState({ subProject: data.subProject });
        }

        this.setState({
          projectClass: data.projectClasses,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          vendorLists: response.data.data,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          projectLists: response.data.data,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          userDeptList: response.data.data.departments,
        });
      })
      .catch((error) => {});

    axios
      .get(`${process.env.REACT_APP_API_KEY}/spreadsheet/budgetLineItem`, {
        headers: {
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((response) => {
        let accountCodeAndName = [];
        for (let i = 0; i < response.data.data.length; i++) {
          accountCodeAndName.push({
            budgetLineItem: response.data.data[i].budgetLineItem,
            accountCodeAndName: response.data.data[i].accountCode + ' ' + response.data.data[i].accountName,
          });
        }

        this.setState({
          accountCodeAndName: accountCodeAndName,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Cost of Services`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        let cocExpenses = [];
        for (let i = 0; i < response.data.data.length; i++) {
          cocExpenses.push(response.data.data[i].accountCode + ' ' + response.data.data[i].accountName);
        }

        this.setState({
          cocExpenses: cocExpenses,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Advances`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        let advances = [];
        for (let i = 0; i < response.data.data.length; i++) {
          advances.push(response.data.data[i].accountCode + ' ' + response.data.data[i].accountName);
        }
        this.setState({
          advances: advances,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/PPE Accounts`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        let ppeAccount = [];
        for (let i = 0; i < response.data.data.length; i++) {
          ppeAccount.push(response.data.data[i].accountCode + ' ' + response.data.data[i].accountName);
        }
        this.setState({
          ppeAccounts: ppeAccount,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Admin Expenses`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        let adminExpenses = [];
        for (let i = 0; i < response.data.data.length; i++) {
          adminExpenses.push(response.data.data[i].accountCode + ' ' + response.data.data[i].accountName);
        }
        this.setState({
          adminExpenses: adminExpenses,
        });
      })
      .catch((error) => {});

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          advancesProjectClass: response.data.data,
        });
      })
      .catch((error) => {});
  }

  checkStateValue = (e) => {
    e.preventDefault();
  };

  handleChangeRequestField = (e) => {
    e.preventDefault();

    if (e.target.name === 'vendor') {
      this.setState({ vendorError: true });
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          //
          this.setState({
            vatTypeSelector: response.data.data.vatType,
          });
          // ==================================================================================
          // VENDOR BP CODE WILL GET THE WTAX

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              //
              let newArray = response.data.data;
              const none = {
                wTaxCode: 'X1',
                wTaxName: '',
                wTaxDisplayName: 'None ',
                rate: '0',
              };
              newArray.push(none);
              this.setState({
                wTaxRates: newArray,
              });
              //
            })
            .catch((error) => {});

          // ==================================================================================
        })
        .catch((error) => {});

      if (!this.state.vendorLists.includes(document.getElementById(`${e.target.id}`).value)) {
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[0].innerText = 'Invalid Input';
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[1].innerText =
          ' ' + '(Please input a valid data included in the list)';
        this.setState({ vendorErr: 1 });
      } else {
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[0].innerText = '';
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[1].innerText = '';
        this.setState({ vendorErr: 0 });
      }
    }

    if (e.target.name === 'receivingDate') {
      this.setState({ receivingDate: e.target.value });
      if (this.state.termDays) {
        const date = new Date(this.state.receivingDate);
        date.setDate(date.getDate() + parseInt(this.state.termDays));
        this.setState({
          dueDate: this.formatDate(date),
        });
      }
    }
    if (e.target.name === 'termDays') {
      if (e.target.value < 0) {
        alert('Enter positive numbers only!');
      } else {
        this.setState({ termDays: e.target.value });
        if (this.state.receivingDate) {
          const date = new Date(this.state.receivingDate);
          date.setDate(date.getDate() + parseInt(this.state.termDays));
          this.setState({
            dueDate: this.formatDate(date),
          });
        }
      }
    }

    if (e.target.name === 'particulars') {
      this.setState({ particularsError: true });
      if (e.target.value === '') {
        this.setState({ particularsErr: 1 });
      } else {
        this.setState({ particularsErr: 0 });
      }
    }

    if (e.target.name === 'requestingDepartment') {
      const copyOfProjectClass = [...this.state.projectClass];
      const projectObj = { ...copyOfProjectClass[0] };
      projectObj.classDepartment = e.target.value;
      copyOfProjectClass[0] = projectObj;
      this.setState({ projectClass: copyOfProjectClass });
    }

    //__________________TRIGGERS THE LOAD OF BUDGET LINE ITEM___________________//
    if (e.target.name === 'project') {
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(() => (this.state.projectClass[i].glCategory = ''));
      }
      // ================================================================================================
      this.setState({ projectError: false, projectErr: 0 });

      if (e.target.value === '') {
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[0].innerText = '';
        document.getElementById(`${e.target.id}`).nextElementSibling.nextElementSibling.children[1].innerText = '';
        this.setState({ projectErr: 1 });
      }

      // =======================================================
    }

    if (e.target.name === 'file' && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split('.');
      let fileExtension = fileName[fileName.length - 1];
      this.setState({ fileError: true });
      if (fileExtension !== 'pdf') {
        this.setState({ fileErr: true });
      } else {
        this.setState({ fileErr: 0 });
      }
    }

    if (e.target.name === 'file' && e.target.files.length === 0) {
      this.setState({ fileErr: 1 });
    }

    if (e.target.name === 'project') {
      this.setState({
        accountTypes: [],
      });
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          //
          this.setState({
            projectCode: response.data.data.projectCode,
          });
          //
          if (this.state.requestingDepartment) {
            const params = {
              projectCode: response.data.data.projectCode,
              department: this.state.requestingDepartment,
            };
            axios({
              method: 'POST',
              url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem/dropdown`,
              headers: {
                'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                Authorization: `Bearer ${localStorage.token}`,
              },
              data: params,
            })
              .then((response) => {
                //
                let budgetLineItem = response.data.data;
                this.setState({
                  accountTypes: budgetLineItem,
                });
              })
              .catch((error) => {
                this.setState({
                  accountTypes: [],
                });
              });
          }
        })
        .catch((error) => {});
    }

    if (e.target.name === 'file' && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split('.');
      let fileExtension = fileName[fileName.length - 1];
      fileExtension !== 'pdf'
        ? (document.getElementById('documentEmptyError').innerText = '(Please upload a valid file(pdf).)')
        : (document.getElementById('documentEmptyError').innerText = '');
    }

    let file = null;
    if (e.target.name === 'file') {
      //
      file = e.target.files[0];
      //
      this.setState({
        [e.target.name]: e.target.files[0],
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    //

    this.setState({
      error: this.state.vendorErr + this.state.particularsErr + this.state.projectErr + this.state.fileErr,
    });
    //
  };

  handleChangeProjectClassValue = (e, index, key) => {
    let projectClassCopy = [...this.state.projectClass];
    if (e.target.name === 'classDepartment') {
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      this.setState({ projectClass: projectClassCopy });
    }
    if (e.target.name === 'glCategory' || e.target.name === 'glAccount' || e.target.name === 'projectClass' || e.target.name === 'itemCode') {
      if (e.target.name === 'glCategory') {
        const json = JSON.parse(e.target.value);
        projectClassCopy[parseInt(e.target.id)].glCategory = json.budgetLineItem;
      } else {
        projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      }
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === 'description1' || key === 'description2') {
      projectClassCopy[index][key] = e.target.value.trimLeft();
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === 'itemCode') {
      projectClassCopy[index][key] = e.target.value.trimRight();
      this.setState({ projectClass: projectClassCopy });
    }

    if (e.target.name === 'grossPricePerItem') {
      const grossPrice = e.target.value.split('.');
      if (grossPrice[0].length <= 12) {
        // projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
        // this.setState({projectClass: projectClassCopy})
        this.projectClassComputation(
          1,
          e.target.value,
          this.state.projectClass[index].vatType,
          this.state.projectClass[index].wTaxType,
          projectClassCopy,
          index,
          'grossPricePerItem'
        );
      }
    }
    if (e.target.name === 'vatType') {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        e.target.value,
        this.state.projectClass[index].wTaxType,
        projectClassCopy,
        index,
        'vatType'
      );
    }

    if (e.target.name === 'wTaxType') {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        this.state.projectClass[index].vatType,
        e.target.value,
        projectClassCopy,
        index,
        'wTaxType'
      );
    }

    // EXTRACT GL ACCOUNT NAME

    // CHANGE GL NAME LISTS

    if (e.target.name === 'glCategory') {
      const value = JSON.parse(e.target.value);
      projectClassCopy[parseInt(e.target.id)].glAccount = `${value.accountCode} ${value.accountName}`;
      projectClassCopy[parseInt(e.target.id)].budgetLineItem = value.budgetLineItem;
      this.setState({
        projectClass: projectClassCopy,
      });
    }
    if (e.target.name === 'projectClass') {
      projectClassCopy[parseInt(e.target.id)].projectClass = e.target.value;
    }
  };

  addProjectClass = (e) => {
    e.preventDefault();
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: '',
          glAccount: '',
          description1: '',
          description2: '',
          itemNumber: '',
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: '1OV',
          vatType: 'None IVAT-X1',
          vatTypeValue: 1,
          wTax: 0,
          wTaxCode: 'X1',
          wTaxType: 'X1',
          wTaxRate: '0',
          wTaxTypeValue: 0,
          wTaxTypeString: '',
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: '',
          subTotalGrossPrice: 0.0,
          subTotalNetPrice: 0.0,
          classDepartment: this.state.requestingDepartment,
        },
      ],
    });
  };

  handleSubmitNonPo = (e) => {
    if (this.state.requestType === 'PO Item') {
      if (this.state.poNumber === null || this.state.poNumber === '') {
        document.getElementById('formHintContainer').style.display = 'block';
      }
    }
    e.preventDefault();

    document.getElementById('page1').style.display = 'block';
    let array = this.state.projectClass;

    let formData = new FormData();

    let nonPoForm = {
      department: this.state.requestingDepartment,
      departmentApprover: '5def0fc26501e01d3c1b3b45',
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,

      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: 'Non PO Item',
      status: 'For Approval',
      unitPrice: this.state.unitPrice,
    };

    formData.set('crfForm', JSON.stringify(nonPoForm));
    formData.append('supportingDocuments', this.state.file);

    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        this.setState({
          redirect: true,
          crfId: `/CheckRequest/${response.data.Data._id}`,
        });
        document.getElementById('modalBody').style.display = 'none';
      })
      .catch((error) => {});
  };

  handleDraftNonPo = (e) => {
    e.preventDefault();

    let array = this.state.projectClass;
    let formData = new FormData();
    const newProjectClass = [];

    let nonPoForm = {
      poNumber: this.state.poNumber,
      vendor: this.state.vendor,
      department: this.state.requestingDepartment,
      particulars: this.state.particulars,
      project: this.state.project,
      subProject: this.state.subProject,
      projectClasses: this.state.projectClass,
      requestingGrossPrice: this.state.requestingGrossPrice,
      requestingAmount: this.state.requestingAmount,
    };

    formData.set('crfForm', JSON.stringify(nonPoForm));
    formData.append('supportingDocuments', this.state.file);

    document.getElementById('modalBody').style.display = 'block';
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft/${this.props.crfId}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        if (response.data.data === 'Successfully updated CRF Form') {
          window.location.reload();
        }
      })
      .catch((error) => {});
  };

  handleRemoveProjectClass = (e, index) => {
    e.preventDefault();
    const projectClass = [...this.state.projectClass];
    projectClass.splice(index, 1);
    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;
    for (let obj of projectClass) {
      requestingGrossPrice = parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount = parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  localValidationProjectClasses = async (projectClasses, requestType) => {
    let validationRemarks = null;
    let countIndex = 0;
    for (const obj of projectClasses) {
      console.log(obj);
      countIndex = countIndex + 1;
      if (obj.glCategory === '') {
        alert(`Project class ${countIndex}: glCategory is required`);
        validationRemarks = 'Failed';
        break;
      }
      // if (obj.glCategory === "Advances") {
      //   if (!obj.projectClass) {
      //     alert(`Project class ${countIndex}: Project class is required`);
      //     validationRemarks = "Failed";
      //     break;
      //   }
      //   const { data } = await getData(
      //     `/api/projectClasses/${obj.projectClass}`
      //   );

      //   // if (data === null) {
      //   //   alert(
      //   //     `Project class ${countIndex}: Please make sure that the project class is valid`
      //   //   );
      //   //   validationRemarks = "Failed";
      //   //   break;
      //   // }
      // }
      // if (obj.glAccount === '') {
      //   alert(`Project class ${countIndex}: glAccount is required`);
      //   validationRemarks = 'Failed';
      //   break;
      // }
      if (requestType === 'PO Item') {
        if (!obj.itemCode) {
          alert(`Project class ${countIndex}: itemNo is required`);
          validationRemarks = 'Failed';
          break;
        }
        if (obj.itemCode) {
          const { data } = await getData(`/api/itemNo/${obj.itemCode}`);
          if (data === null) {
            alert(`Project class ${countIndex}: Please make sure that the item number is valid`);
            validationRemarks = 'Failed';
            break;
          }
        }
      }
      if (obj.description1 === '') {
        alert(`Project class ${countIndex}: description 1 is required`);
        validationRemarks = 'Failed';
        break;
      }
      if (obj.grossPricePerItem === 0) {
        alert(`Project class ${countIndex}: gross price is required`);
        validationRemarks = 'Failed';
        break;
      }
      if (obj.vatType === '') {
        alert(`Project class ${countIndex}: vatType is required`);
        validationRemarks = 'Failed';
        break;
      }
      if (obj.wTaxType === '') {
        alert(`Project class ${countIndex}: wTaxType is required`);
        validationRemarks = 'Failed';
        break;
      }
    }
    return validationRemarks;
  };

  handleSubmitDraft = async (e, key) => {
    e.preventDefault();
    if (key === 'fromFirstPage') {
      const copyOfProjectClass = [...this.state.projectClass];
      const projectObj = { ...copyOfProjectClass[0] };
      projectObj.classDepartment = this.state.requestingDepartment;
      copyOfProjectClass[0] = projectObj;
      this.setState({ projectClass: copyOfProjectClass });
    }

    this.setState({ isLoading: true });

    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        updateProgress(percentCompleted);
      },
    };

    let formData = new FormData();
    const newProjectClass = [];

    if (this.state.requestType === 'PO Item') {
      this.setState({ isLoading: true });

      let nonPoForm = {
        dueDate: this.state.dueDate,
        poNumber: this.state.poNumber,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        releasingCenter: this.state.releasingCenter,
        status: 'For Approval',
      };
      const fieldToValidate = localValidation(nonPoForm);
      if (fieldToValidate !== null) {
        this.setState({ isLoading: false });

        alert(`${fieldToValidate} is required`);
        return 'remainOnFirstPage';
      } else {
        this.setState({ isLoading: false });
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
        const project = await getData(`/api/projects/${nonPoForm.project}`);

        if (nonPoForm.poNumber.length !== 9 || nonPoForm.poNumber[0] !== '1') {
          alert('PO number must be 9 digits and should start with number 1');
          return 'remainOnFirstPage';
        }
        if (vendor.data === null) {
          alert('Please make sure that the vendor is valid');
          return 'remainOnFirstPage';
        }
        if (project.data === null) {
          alert('Please make sure that the project is valid');
          return 'remainOnFirstPage';
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(`/api/checkRequestForm/${this.props.crfId}`);
          const { supportingDocuments } = crf.data;
          if (!supportingDocuments) {
            alert('Supporting documents is required');
            return 'remainOnFirstPage';
          }
        }
        if (key === 'fromFirstPage') return;
        const validationProjectClasses = await this.localValidationProjectClasses(nonPoForm.projectClasses, 'PO Item');
        if (validationProjectClasses) return;
      }

      formData.set('crfForm', JSON.stringify(nonPoForm));
      formData.append('supportingDocuments', this.state.file);

      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.crfId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        },
        onUploadProgress: config.onUploadProgress,
      })
        .then((response) => {
          this.setState({
            isLoading: false,
            redirect: true,
            crfId: `/CheckRequest/${this.props.crfId}`,
          });

          window.location.reload(false);
        })
        .catch((error) => {
          this.setState({ isLoading: false });

          alert(error.data.Error);
          document.getElementById('formHintContainer').style.display = 'block';
          document.getElementById('draftErrorHint').innerText =
            ' ' + 'Please make sure you filled up the required fields at Project Class' + ' ' + (parseInt(error.data.Error.slice(-1)) + 1);
          window.location.reload(false);
        });
    } else {
      this.setState({ isLoading: true });
      let nonPoForm = {
        dueDate: this.state.dueDate,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        releasingCenter: this.state.releasingCenter,
        subProject: this.state.subProject,
        particulars: this.state.particulars,
        status: 'For Approval',
      };

      const fieldToValidate = localValidation(nonPoForm);

      if (fieldToValidate !== null) {
        this.setState({ isLoading: false });
        alert(`${fieldToValidate} is required`);
        return 'remainOnFirstPage';
      } else {
        this.setState({ isLoading: false });
        const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
        const project = await getData(`/api/projects/${nonPoForm.project}`);
        if (vendor.data === null) {
          alert('Please make sure that the vendor is valid');
          return 'remainOnFirstPage';
        }
        if (project.data === null) {
          alert('Please make sure that the project is valid');
          return 'remainOnFirstPage';
        }
        if (this.state.file === null || this.state.fileErr === 1) {
          const crf = await getData(`/api/checkRequestForm/${this.props.crfId}`);
          const { supportingDocuments } = crf.data;
          if (!supportingDocuments) {
            alert('Supporting documents is required');
            return 'remainOnFirstPage';
          }
        }
        if (key === 'fromFirstPage') return;
        const validationProjectClasses = await this.localValidationProjectClasses(nonPoForm.projectClasses, 'Non PO Item');
        if (validationProjectClasses) return;
      }

      document.getElementById('modalBody').style.display = 'block';
      formData.set('crfForm', JSON.stringify(nonPoForm));
      formData.append('supportingDocuments', this.state.file);

      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.crfId}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`,
        },
        onUploadProgress: config.onUploadProgress,
      })
        .then((response) => {
          this.setState({
            isLoading: false,
            redirect: true,
            crfId: `/CheckRequest/${this.props.crfId}`,
          });

          window.location.reload(false);
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          alert('Server Error');
          console.log(error);

          if (error.data.Error === 'projectClass code doesnt exist') {
            document.getElementById('formHintContainer').style.display = 'block';
            document.getElementById('draftErrorHint').innerText = 'You have inputed an invalid Project Class value.';
          }
          window.location.reload(false);
        });
    }
  };

  handleDownloadPdf = () => {
    axios(`${process.env.REACT_APP_API_KEY}/api/uploads/${this.props.crfId}`, {
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Api-Key': '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const file = new Blob([response.data], {
          type: 'application/pdf',
        });

        const fileURL = URL.createObjectURL(file);

        window.open(fileURL);
      })
      .catch((error) => {});
  };

  handleSavedReturned = async (id) => {
    let nonPoForm = {};
    if (this.state.requestType === 'Non PO Item') {
      nonPoForm = {
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        dueDate: this.state.dateNeeded,
        subProject: this.state.subProject,
        releasingCenter: this.state.releasingCenter,
        particulars: this.state.particulars,
        requestType: 'Non PO Item',
      };
    } else {
      nonPoForm = {
        dueDate: this.state.dueDate,
        poNumber: this.state.poNumber,
        department: this.state.requestingDepartment,
        vendor: this.state.vendor,
        project: this.state.project,
        projectClasses: this.state.projectClass,
        subProject: this.state.subProject,
        releasingCenter: this.state.releasingCenter,
        particulars: this.state.particulars,
        status: 'For Approval',
      };
    }

    let formData = new FormData();
    formData.set('crfForm', JSON.stringify(nonPoForm));
    formData.append('supportingDocuments', this.state.file);

    const response = await savedReturned({ id, formData });
  };

  render() {
    const vatTypeSelections = (
      <>
        <option value="None IVAT-X1">None IVAT-X1</option>
        <option value="Goods IVAT-G">Goods IVAT-G</option>
        <option value="Services IVAT-S">Services IVAT-S</option>
      </>
    );
    if (this.state.redirect === true) {
      return <Redirect to={this.state.crfId} />;
    }

    return (
      <form id="mainPage">
        <PoModal />
        {this.state.progress > 0 && <PoModalReturned progress={this.state.progress} />}
        <div id="mainPanel">
          {this.props.componentRemarks}
          <div className="formContainer">
            <Transition
              native
              items={this.state.showForm}
              from={{ opacity: 0 }}
              enter={{ opacity: 1 }}
              leave={{ opacity: 0 }}
              config={{ duration: 300 }}
            >
              {(show) =>
                show &&
                ((props) => (
                  <animated.div style={props}>
                    <DraftView
                      releasingCenter={this.state.releasingCenter}
                      savedReturned={this.handleSavedReturned}
                      dueDate={this.state.dueDate}
                      termDays={this.state.termDays}
                      receivingDate={this.state.receivingDate}
                      isLoading={this.state.isLoading}
                      requestingGrossPrice={this.state.requestingGrossPrice}
                      requestingAmount={this.state.requestingAmount}
                      handleDownloadPdf={this.handleDownloadPdf}
                      requestType={this.state.requestType}
                      fileText={this.state.fileText}
                      cocExpenses={this.state.cocExpenses}
                      advances={this.state.advances}
                      ppeAccounts={this.state.ppeAccounts}
                      adminExpenses={this.state.adminExpenses}
                      accountCodeAndName={this.state.accountCodeAndName}
                      advancesProjectClass={this.state.advancesProjectClass}
                      userDeptList={this.state.userDeptList}
                      requestingDepartment={this.state.requestingDepartment}
                      poNumber={this.state.poNumber}
                      vendor={this.state.vendor}
                      vendorError={this.state.vendorError}
                      vendorErr={this.state.vendorErr}
                      particulars={this.state.particulars}
                      particularsError={this.state.particularsError}
                      particularsErr={this.state.particularsErr}
                      project={this.state.project}
                      projectError={this.state.projectError}
                      projectErr={this.state.projectErr}
                      file={this.state.file}
                      fileError={this.state.fileError}
                      fileErr={this.state.fileErr}
                      subProject={this.state.subProject}
                      projectClass={this.state.projectClass}
                      accountTypes={this.state.accountTypes}
                      vatTypeSelector={this.state.vatTypeSelector}
                      vatTypeSelections={vatTypeSelections}
                      wTaxRates={this.state.wTaxRates}
                      handleChangeRequestField={this.handleChangeRequestField}
                      handleChangeProjectClassValue={this.handleChangeProjectClassValue}
                      budgetLineItem={this.state.budgetLineItem}
                      addProjectClass={this.addProjectClass}
                      handleSubmitNonPo={this.handleSubmitNonPo}
                      handleDraftNonPo={this.handleDraftNonPo}
                      checkStateValue={this.checkStateValue}
                      file={this.state.file}
                      vendorLists={this.state.vendorLists}
                      projectLists={this.state.projectLists}
                      requestId={this.state.requestId}
                      handleRemoveProjectClass={this.handleRemoveProjectClass}
                      addedProjectClass={this.state.addedProjectClass}
                      changed={this.onChangedHandler}
                      onBlurNumber={this.onBlurNumber}
                      handleSubmitDraft={this.handleSubmitDraft}
                    />
                  </animated.div>
                ))
              }
            </Transition>
          </div>
          {/* END OF FORM */}
        </div>
      </form>
    );
  }
}

const dark = {
  color: 'black',
};

export default NonPoItems;
